import { withAuthenticationRequired } from '@tom-ui/utils'
import { renderIsoCodeMappingField } from '@host/components/iso-code-mapping-input/IsoCodeMappingField'
import { usePlanningStore } from '@tom-ui/planning'
import React from 'react'

export const withNumericReleaseSetup = (Component: React.ComponentType<any>) => {
  const ComponentWithSetup = (props: any) => {
    const { isoCodeMappingInputStore } = usePlanningStore()

    if (renderIsoCodeMappingField) {
      isoCodeMappingInputStore.renderIsoCodeMappingField = renderIsoCodeMappingField
    }

    return <Component {...props} />
  }

  return withAuthenticationRequired(ComponentWithSetup)
}
